import { IMonth, ICalendarState, IEventFilter, defaultCalendarModel } from '../../classes/calendar';
import { IEvent } from '../../custom/classes/event';

import { ActionType, ICalendarStateAction } from '../../classes/calendar-actions';

import * as moment from 'moment';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function calendarReducer(state: ICalendarState<IEvent> = defaultCalendarModel, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.RequestEvents: {
            return { ...state, updating: true } as ICalendarState<IEvent>;
        }
        case ActionType.UpdateEventFilter: {
            const updating = true;
            const addedFilterFunction = action.value;

            var eventFilter: IEventFilter[] = null;
            if (state.eventFilter.some(filter => { return filter.key === addedFilterFunction.key })) {
                eventFilter = state.eventFilter.filter(filter => !(filter.key === addedFilterFunction.key)).concat([addedFilterFunction]);
            } else {
                eventFilter = state.eventFilter.concat([addedFilterFunction])
            }
            const filterFunction = (event) => eventFilter.map(fil => { return fil.filter; }).every(f => f(event));

            return { ...state, eventFilter, filterFunction, updating } as ICalendarState<IEvent>;
        }

        case ActionType.RemoveEventFilter: {
            const eventFilter = state.eventFilter.filter(filter => filter.key !== action.value);
            const filterFunction = (event: IEvent) => eventFilter.map(filter => filter.filter).every(func => func(event));

            return { ...state, eventFilter, filterFunction, updating: true } as ICalendarState<IEvent>;
        }

        case ActionType.RemoveAllEventFilters: {
            return { ...state, eventFilter: [], filterFunction: (event: IEvent) => true, updating: true } as ICalendarState<IEvent>;
        }

        case ActionType.EventApiError: {
            return { ...state, updating: false, apiError: action.value } as ICalendarState<IEvent>;
        }

        case ActionType.ChangeProductionSeasonFilter: {
            const productionSeasonFilter = action.value as number;
            const updating = true;
            return { ...state, productionSeasonFilter, updating } as ICalendarState<IEvent>;
        }
        case ActionType.NextMonth: {
            // state.startDate.add(1, 'month').startOf('month');
            let newEndDate = state.endDate.clone().add(1, 'month').endOf('month');
            let newCurrMoment = state.currentDate.clone().add(1, "month");

            if (newCurrMoment.isAfter(state.endDate)) {
                return { ...state, updating: true, specificDates: false, currentDate: newCurrMoment, endDate: newEndDate } as ICalendarState<IEvent>;
            }

            return { ...state, currentDate: newCurrMoment } as ICalendarState<IEvent>;
        }
        case ActionType.UpdateEvents: {
            const events = action.value as Array<IMonth<any>>;

            return { ...state, updating: false, events: events } as ICalendarState<IEvent>;
        }
        case ActionType.UpdateUpNext: {
            const upNext = action.value as IEvent;

            return { ...state, updating: false, upNext: upNext } as ICalendarState<IEvent>;
        }
        case ActionType.PreviousMonth: {
            // state.endDate.add(-1, 'month').endOf('month');

            let newStartDate = state.startDate.clone().add(-1, 'month').startOf('month');
            let newCurrMoment = state.currentDate.clone().add(-1, "month");

            if (newCurrMoment.isBefore(state.startDate)) {
                return { ...state, updating: true, specificDates: false, currentDate: newCurrMoment, startDate: newStartDate } as ICalendarState<IEvent>;
            }
            return { ...state, currentDate: newCurrMoment } as ICalendarState<IEvent>;
        }
        case ActionType.AddDays: {
            const extendEvents = action.value.extendDays;

            if (extendEvents) {
                if (action.value.numberOfDays > 0) {
                    state.endDate = moment(state.endDate.add(action.value.numberOfDays, 'day'));
                } else {
                    state.startDate = moment(state.startDate.add(action.value.numberOfDays, 'day'));
                }
            } else {
                state.startDate = moment(state.startDate.add(action.value.numberOfDays, 'day'));
                state.endDate = moment(state.endDate.add(action.value.numberOfDays, 'day'));
            }

            const updating = true;
            return { ...state, updating, extendEvents, specificDates: true } as ICalendarState<IEvent>;
        }
        case ActionType.GoToMonth: {
            const setDate = action.value.clone() as moment.Moment;

            let newStart: moment.Moment;
            let newEnd: moment.Moment;

            let mustUpdate = false;

            if (setDate.isBefore(state.startDate)) {
                newStart = setDate.clone().startOf("month");
                mustUpdate = true;
            } else {
                newStart = state.startDate.clone();
            }

            if (setDate.isAfter(state.endDate)) {
                newEnd = setDate.clone().endOf("month");
                mustUpdate = true;
            } else {
                newEnd = state.endDate.clone();
            }

            return {
                ...state,
                updating: mustUpdate,
                specificDates: false,
                currentDate: action.value.clone(),
                startDate: newStart,
                endDate: newEnd
            } as ICalendarState<IEvent>;
        }
        case ActionType.SetMonth: {
            state.startDate = moment(action.value.startOf('month'));
            state.endDate = moment(action.value.endOf('month'));
            const updating = true;
            return { ...state, updating, specificDates: true } as ICalendarState<IEvent>;
        }
        case ActionType.SetDates: {
            state.startDate = action.value.startDate;
            state.endDate = action.value.endDate;
            const updating = true;
            return { ...state, updating, specificDates: true } as ICalendarState<IEvent>;
        }
        case ActionType.EventUpdated: {
            return { ...state, updating: false } as ICalendarState<IEvent>;
        }
        case ActionType.BrowserNavigated: {
            state = action.value.state;
            state.updating = action.value.shouldUpdate;
            return state as ICalendarState<IEvent>;
        }
        default:
            return state;
    }
}
